export enum WebPushNotificationPermissionTypeEnum {
  DEFAULT = "default",
  GRANTED = "granted",
  DENIED = "denied",
}
